// extracted by mini-css-extract-plugin
export default {"close_btn":"CloseButton_close_btn__UsX59","close_text":"CloseButton_close_text__xlGDv"};